import { Vitalsconfig as VitalsConfig } from "src/common/utils";

/// handles the polling of the DCAT
class PollVitalsHandler {
    private readonly POLL_URL = VitalsConfig.server + ':' + VitalsConfig.dcatPort;
    private controller: AbortController | null = null;
    private signal: AbortSignal | null = null;

    private timerHandle: number;
    public vitalsRunning: boolean;
    private stopping: boolean;
    private pollComplete: (vitalsRunning: boolean) => void;

    constructor(pollComplete: (vitalsRunning: boolean) => void) {
        this.timerHandle = -1;
        this.vitalsRunning = false;
        this.stopping = false;
        this.pollComplete = pollComplete;

        this.Start = this.Start.bind(this);
        this.Stop = this.Stop.bind(this);
        this.timerCallback = this.timerCallback.bind(this);
    }

    public Start = () => {
        this.controller = new AbortController();
        this.signal = this.controller.signal;
        this.stopping = false;
        this.vitalsRunning = false;

        //set timeout
        this.timerHandle = window.setTimeout(this.timerCallback);
    }

    public Stop = () => {
        //stop the timer
        if (this.timerHandle >= 0) {
            window.clearTimeout(this.timerHandle);
        }
		this.stopping = true;
		if (this.controller) {
			this.controller.abort();
		}
        this.pollComplete(this.vitalsRunning);
    }

    private timerCallback = () => {
        //stop the timer
        if (this.timerHandle >= 0) {
            window.clearTimeout(this.timerHandle);
        }
        //poll the vitals app. If found, set vitals running flag
        fetch(this.POLL_URL, {
            method: 'get',
            mode: 'no-cors',
            signal: this.signal
        })
            .then(response => {
                if (response) {
                    console.log('Polling VITALS: running');
                    //vitals was found
                    this.vitalsRunning = true;
                    this.timerHandle = window.setTimeout(this.timerCallback, VitalsConfig.pollInterval);
                }
            })
            .catch(() => {
                //if vitals was previously running, but isn't now, consider the poll complete
                if (this.vitalsRunning) {
                    console.log('Polling VITALS: stopping');
                    this.Stop();
                }
                else if (!this.stopping) {
                    console.log('Polling VITALS: not found');
                    this.timerHandle = window.setTimeout(this.timerCallback, VitalsConfig.pollInterval);
                }
            })
    }
}

export default PollVitalsHandler;